import { render } from "./HomeMyDataPassword.vue?vue&type=template&id=7dd4459a"
import script from "./HomeMyDataPassword.vue?vue&type=script&lang=js"
export * from "./HomeMyDataPassword.vue?vue&type=script&lang=js"

import exportComponent from "E:\\workspace_vue\\vue_myLogin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__